import { ReactNode } from 'react';

export interface HeaderSubMenu {
  label: string;
  subRoute: string;
}

export interface HeaderMainMenu {
  id: number;
  label: string;
  route?: string;
  subMenu?: Array<HeaderSubMenu>;
  eventName: string;
}

export interface HeaderDropBoxMenu {
  id: number;
  icon: ReactNode;
  label: string;
  route: string;
  subMenu?: Array<HeaderSubMenu>;
  eventName: string;
  visible: boolean;
  isTokenCheck: boolean;
}

export enum HeaderType {
  WithMobileHeader = 'withMobileHeader',
}
